export default function Footer() {
  return (
    <footer className="bg-dark-lighter border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-8 py-12">
        <div className="grid grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/8a970083-971d-4b19-9687-f1352617b959.png" 
                alt="Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold text-white">SaaS Solutions</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Maßgeschneiderte SaaS-Lösungen für modernes Business. Individuelle Softwareentwicklung mit modernster Technologie.
            </p>
            <div className="text-gray-400 text-sm leading-relaxed">
              <strong className="text-white">Future Now UG</strong><br />
              Max-Planck-Str. 4<br />
              85609 Aschheim<br />
              <a href="mailto:info@future-now.online" className="text-primary hover:text-primary-light transition-colors cursor-pointer">
                info@future-now.online
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold mb-4">Produkte</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Lead-Management
                </a>
              </li>
              <li>
                <a href="#features" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  E-Mail-Automatisierung
                </a>
              </li>
              <li>
                <a href="#features" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  CRM-System
                </a>
              </li>
              <li>
                <a href="#features" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Analytics Dashboard
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Unternehmen</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Über uns
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Karriere
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Kontakt
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Rechtliches</h4>
            <ul className="space-y-3">
              <li>
                <a href="/datenschutz" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="/impressum" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Impressum
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  AGB
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 text-sm cursor-pointer">
                  Cookie-Richtlinie
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex items-center justify-between">
          <p className="text-gray-400 text-sm">
            © 2025 Future Now UG. Alle Rechte vorbehalten. | GF: Olaf Niggemann
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 cursor-pointer">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 cursor-pointer">
              <i className="ri-twitter-x-fill text-xl"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-primary transition-colors duration-300 cursor-pointer">
              <i className="ri-github-fill text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
